import { request, Paginated } from "utils/api";
import { Booking, BookingParticipant } from "api/bookings";
import { ReducedUserProfile } from "api/user";

// activity item from GET /admin/activity
export interface ActivityItem {
    activityType: "active" | "passive",
    booking: Booking,
    changes: any,
    createdAt: string,
    id: string,
    participant: BookingParticipant,
    user: ReducedUserProfile,
}

// fetch activities (GET /admin/activity)
export const getActivities = (data: { clubId?: string, limit: number, offset: number }) => request<Paginated<ActivityItem>>({
    data,
    endpoint: "/admin/activity",
    method: "get",
});
